import { FormValue } from "../../../../../../harmony/angular";
import { PublicationTemplateType } from "../../data/entities/publication-templates.entity";
import {
  FormToApiMapper,
  FormToPreviewMapper,
  getLinkByLinkType,
} from "../../domain/mappers/publication-template.mapper";
import { PartialPublicationTemplate } from "../../domain/models/publication-template";
import { GooglePerformanceMaxForm } from "./google-performance-max-form/google-performance-max-form.component";
import { GooglePerformanceMaxCreateDto } from "./google-performance-max.create-dto";

export class GooglePerformanceMaxFormToApiMapper
  implements
    FormToApiMapper<GooglePerformanceMaxForm, GooglePerformanceMaxCreateDto>
{
  public map(
    form: FormValue<GooglePerformanceMaxForm>,
  ): GooglePerformanceMaxCreateDto {
    return {
      publicationTemplateType: PublicationTemplateType.GooglePerformanceMax,
      imageIds: form.images!.map((media) => media.id),
      logoIds: form.logo?.id ? [form.logo.id] : undefined,
      videoIds: form.videos?.map((media) => media.id),
      landingPageUrl: getLinkByLinkType(form.linkType, form.link),
      headlines: form.headlines!.filter((headline) => !!headline) as string[],
      longHeadlines: form.longHeadlines!.filter(
        (headline) => !!headline,
      ) as string[],
      descriptions: form.descriptions!.filter((desc) => !!desc) as string[],
    };
  }
}

export class GooglePerformanceMaxFormToPreviewMapper
  implements
    FormToPreviewMapper<
      GooglePerformanceMaxForm,
      PublicationTemplateType.GooglePerformanceMax
    >
{
  public map(
    form: FormValue<GooglePerformanceMaxForm>,
  ): PartialPublicationTemplate<PublicationTemplateType.GooglePerformanceMax> {
    return {
      type: PublicationTemplateType.GooglePerformanceMax,
      images: form.images?.length ? form.images : undefined,
      logos: form.logo ? [form.logo] : undefined,
      videos: form.videos?.length ? form.videos : undefined,
      headlines: form.headlines.map((headline) => headline ?? undefined),
      descriptions: form.descriptions.map((desc) => desc ?? undefined),
    };
  }
}
